import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./tile-summary-row.html';
import styles from './tile-summary-row-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: cssUtil.hashTemplate(template, styles)
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/tileLayout/SummaryRow/tileSummaryRow.js
// module id = 2044
// module chunks = 0